import { InputMask } from "@react-input/mask";
import { useState } from "react";
import { Button, FloatingLabel, Form, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Countdown from "react-countdown"
import { ArrowLeftCircle } from "react-bootstrap-icons";
import { usePostRegisterPhoneMutation, usePostSmsLoginMutation, usePostUserTokenMutation } from "../../features/CallTPApi";
import { setAlertMsgStore } from "../../features/alertMsgSlisce";
import { useTokenTP } from "../../features/useTokenTP";
import { Link } from "react-router-dom";
// import { Link } from "react-router";


interface SmsLogin {
    phone: string;
    smsCode: string;
}

const renderer = ({ formatted }: any) => {
    return <span>{formatted.minutes}:{formatted.seconds}</span>;
}
const PinCodeForm = ({ phone, setShowPinInput }: { phone: string | null, setShowPinInput: (state: boolean) => void }) => {

    const { setTokenTP, setTokenAuthenticationTP } = useTokenTP()
    const [pinError, setPinError] = useState<string | null>(null)
    const [isValid, setIsValid] = useState<boolean>(false)
    const [btnResendShow, setBtnResendShow] = useState(false)
    const [postSmsLogin, { isLoading: isLoadingSmsLogin }] = usePostSmsLoginMutation()
    const [postUserToken] = usePostUserTokenMutation()

    const pinSend = (pin: any) => {
        if (pin.length === 6) {
            // const personId = localStorage.getItem("personId")
            if (!phone) {
                setAlertMsgStore({ title: "Не удалось найти пользователя", variant: "danger" } as any)
                return;
            }
            const smsLoginBody: SmsLogin = { phone: phone, smsCode: pin }
            postSmsLogin(smsLoginBody).then(async (res: any) => {
                if (!res.error) {
                    setIsValid(true)
                    setTokenTP(res.data.token)
                    setTokenAuthenticationTP(res.data.token)
                    await postUserToken(null).then((r: any) => {
                        if (r.error) {
                            const error = r.error;
                            if (error) {
                            }
                            return;
                        }
                        setTokenTP(r.data.token);
                    });
                }
                else {
                    setPinError("Неправильный пин-код")
                }
            })
        }
        else {
            setPinError("Пин-код должен быть 6 цифры")
        }
    }

    const handleSubmit = (event: any) => {
        event.preventDefault();
        pinSend(event.target.elements.pinCode.value)
    }

    return (
        <div>
            <div style={{ textAlign: 'left' }} className="d-flex mb-2">
                <div className="d-flex" style={{ alignItems: 'center' }}>
                    <Button variant="light" style={{ alignItems: 'center' }}
                        className="p-1 rounded-circle d-flex"
                        onClick={() => { setShowPinInput(false) }}>
                        <ArrowLeftCircle size={24} />
                    </Button>
                </div>
                <div className="ms-2">
                    <h4>
                        Подтвердите вход по смс
                    </h4>
                    <p className="mb-1">
                        Код подтверждения отправлен на номер
                        {/* {authData.phone} */}
                    </p>
                </div>
            </div>
            <Form onSubmit={handleSubmit}>
                <Form.Control
                    className={`justify-content-center ${pinError ? "is-invalid" : ""} ${isValid ? "is-valid" : ""}`}
                    name="pinCode"
                    type="password"
                    autoCorrect="off"
                    spellCheck="false"
                    autoComplete="one-time-code"
                    placeholder=""
                    maxLength={6}
                    style={{ textAlign: 'center' }}
                    onChange={(e) => {
                        setPinError(null)
                        const value = e.target.value
                        if (value.length === 6) {
                            pinSend(value)
                        }
                    }}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                            event.preventDefault();
                        }
                    }} />
                <div className="text-danger is-invalid">
                    {pinError}
                </div>
                {!isLoadingSmsLogin ?
                    <Button disabled={isLoadingSmsLogin} type="submit" className="w-100 mt-3" variant="dark">Подтвердить</Button>
                    :
                    <div className="text-center">
                        <Spinner variant="dark" animation="border" />
                    </div>
                }
            </Form>

            {!btnResendShow ?
                <div className="mt-3 text-center">
                    Повторно отправить код через:
                    <span className="ms-2"></span>

                </div>
                :
                <Button type="button" className="mt-3 btn-lc-rounded w-100" variant="light">Отправить код повторно</Button>
            }
            <div className="text-center">
                <Countdown
                    date={localStorage.getItem("validUntil") as string}
                    autoStart={true}
                    renderer={renderer}
                    onComplete={() => { setBtnResendShow(true) }}
                    zeroPadTime={2}
                />
            </div>
        </div>
    )
}


export const InputPhone = () => {
    const { register, handleSubmit, formState: { errors }, setError } = useForm<any>()
    const [postRegisterPhone, { isLoading: isLoadinguseRegisterPhone },] = usePostRegisterPhoneMutation<any>()
    const [phone, setPhone] = useState<string | null>(null)
    const dispatch = useDispatch();
    const submit = async (data: any) => {
        data.phone = '+' + data.phone.replace(/\D+/g, "");
        if (data.phone.length !== 12 || data.phone[1] !== '7') {
            if (data.phone[1] === '8') {
                data.phone = '+7' + data.phone.slice(2);
            } else if (data.phone.length !== 12) {
                setError('phone', { type: "custom", message: 'Номер телефона должен быть 11 символов и начинаться с +7' })
                return;
            }
        }
        setPhone(data.phone)
        await postRegisterPhone(data).then((res: any) => {
            if (!res?.error) {
                dispatch(setAlertMsgStore({ title: "Сообщение с кодом подтверждения отправлено на указанный номер.", variant: "success" } as any))
                localStorage.setItem('personId', res.data.personId)
                localStorage.setItem('validUntil', res.data.validUntil)
                setShowPinInput(true)
            }
            else (
                dispatch(setAlertMsgStore({ title: "Ошибка в данных запроса. Пожалуйста, проверьте правильность указанного номера.", variant: "danger" } as any))
            )
        })
    }
    const [showPinInput, setShowPinInput] = useState(false)

    return (
        <>
            {!showPinInput ?
                <Form className="w-100 d-grid gap-2" onSubmit={handleSubmit(submit)}>
                    <FloatingLabel label="Телефон">
                        <InputMask autoComplete="tel" className={`form-control ${errors?.phone?.message !== undefined && 'is-invalid'}`}
                            mask="+_ (___) ___-__-__" replacement={{ _: /\d/ }}
                            placeholder="Телефон" type="tel" {...register('phone', { required: { value: true, message: 'Введите номер телефона' } })} />
                        {/* <Form.Control isInvalid={errors?.phone?.message !== undefined} placeholder="Телефон" type="tel" {...register('phone', { required: { value: true, message: 'Введите номер телефона' } })} /> */}
                        {errors?.phone && <div className="text-danger is-invalid">{errors?.phone?.message as any}</div>}
                    </FloatingLabel>
                    <p className="text-muted ps-1 pr-1 mt-1" style={{ fontSize: '10px', textAlign: 'justify' }}>Во исполнение Федерального закона от 31.07.2023 N 406-ФЗ, авторизация, идентификация и/или аутентификация пользователей сайта осуществляется по номеру мобильного телефона. Без вашего согласия на указанный вами номер не будут направляться рекламные сообщения.</p>
                    <div className="form-check form-switch">
                        <input className={`form-check-input ${errors?.payPolicy ? "is-invalid" : ""} tpswith`} type="checkbox" role="switch" id="rules" {...register('payPolicy', { required: true })} />
                        <label className="form-check-label" htmlFor="rules" style={{ fontSize: '12px' }}>
                            Я ознакомлен с <Link className="text-black" target="_blank" to="https://leningradcenter.ru/api/redirecturls/processing_of_personal_data">целями обработки персональных данных</Link> и даю согласие на <Link className="text-black" target="_blank" to="https://leningradcenter.ru/api/redirecturls/privacy-policy">обработку персональных данных при покупке билетов в соответствии с требованиями Федерального закона № 152-ФЗ «О персональных данных»</Link>
                        </label>
                    </div>
                    {/* <div className="text-danger text-center mb-2">{error}</div> */}
                    {!isLoadinguseRegisterPhone ?
                        <div>
                            <Button type="submit" variant="dark" className="w-100 mb-2">Подтвердить номер</Button>
                        </div>
                        :
                        <div className="text-center">
                            <Spinner onClick={() => { setShowPinInput(true) }} className="m-auto" />
                        </div>
                    }
                </Form>
                :
                <div>
                    <PinCodeForm phone={phone} setShowPinInput={setShowPinInput} />
                </div>
            }
        </>
    )
}